













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
/**
 * ETopPageText is used to standarize look of top element in all pages.
 * It handle page title (h1), description and margins below to have each page at the same level.
 */
export default class ETopPageText extends Vue {
  // h1 text
  @Prop() private maintext!: string;

  // normal text below
  @Prop() private text!: string;

  // margin value - default '0 0 70px 0'
  @Prop() private marginval!: string;
}
